import * as actionTypes from './actionTypes';

export const setLanguage = (language) => {
    return {
        type: actionTypes.SET_LANGUAGE,
        language: language
    }
}

export const setTheme = (theme) => {
    localStorage.setItem("theme", JSON.stringify(theme))
    return {
        type: actionTypes.SET_THEME,
        theme: theme
    }
}

export const setServerError = (value) => {
    return {
        type: actionTypes.SET_SERVER_UNAVAILABLE,
        ifServerUnavailable: value
    }
}